// extracted by mini-css-extract-plugin
module.exports = {"specifications":"styles_specifications__1nzWN","specifications_item":"styles_specifications_item__20W4h","specifications_title":"styles_specifications_title__RKpai"};